import { ActionButton, Dialog, cn } from "@eisox/design-system";
import { ArrowRightIcon, CalendarIcon } from "@eisox/icons";

import { m } from "~/paraglide/messages";

import { PreComfortTimeslotGeneration } from "./pre-comfort-timeslot-generation";

interface PlanningsGenerationDialogProps extends Dialog.RootProps {
  absenceTemperature: number;
  preComfortTemperature: number;
  comfortTemperature?: number;
}

export const PlanningsGenerationDialog: React.FC<PlanningsGenerationDialogProps> = ({
  absenceTemperature,
  preComfortTemperature,
  comfortTemperature,
  children,
  ...props
}) => (
  <Dialog.Root {...props}>
    <Dialog.Trigger asChild>{children}</Dialog.Trigger>
    <Dialog.Content
      className={cn("gap-y-5 md:max-w-[742px] md:gap-y-10 flex w-full flex-col items-center")}
      title={m.plannings_generation()}
      icon={
        <CalendarIcon className="[&_svg]:h-6 [&_svg]:w-6 bg-primary-gray opacity-100 [&_svg]:fill-primary-dark-blue" />
      }
    >
      <p className="font-normal text-left text-base leading-[21px]">{m.precomfort_timeslot_generation_popup_text()}</p>
      <PreComfortTimeslotGeneration absenceTemperature={absenceTemperature} comfortTemperature={comfortTemperature} />
      <PreComfortTimeslotGeneration
        activate
        absenceTemperature={absenceTemperature}
        preComfortTemperature={preComfortTemperature}
        comfortTemperature={comfortTemperature}
      />
      <Dialog.Close asChild>
        <ActionButton className="max-w-fit">
          {m.close()}
          <ArrowRightIcon />
        </ActionButton>
      </Dialog.Close>
    </Dialog.Content>
  </Dialog.Root>
);

PlanningsGenerationDialog.displayName = "PlanningsGenerationDialog";
